import lightFormat from "date-fns/lightFormat";
import Head from "next/head";
import Link from "next/link";
import type { ReactElement } from "react";
import { FormattedDate, FormattedMessage } from "react-intl";
import FundamenteiWithTextLayout from "../layouts/FundamenteiWithTextLayout";

interface IPolicyPageProps {
  title: string;
  lastUpdatedAt: Date;
  children: ReactElement;
}

export default function PolicyPage({ title, lastUpdatedAt, children }: IPolicyPageProps) {
  return (
    <FundamenteiWithTextLayout>
      <Head>
        <title>{title}</title>
      </Head>

      <main className="mx-auto mb-16 mt-8 max-w-7xl font-aeonik font-normal md:mb-12">
        <div>
          <div className="px-4">
            <h1 className="text-center text-3xl font-medium tracking-wide text-gray-800 md:text-left">{title}</h1>
          </div>

          {children}

          <div className="mt-7 flex flex-col items-center justify-between space-y-8 px-4 md:flex-row md:space-y-0">
            <Link href="/" className="text-md font-medium tracking-wide text-blue-600 hover:underline md:text-lg">
              ← <FormattedMessage defaultMessage="Voltar para a página inicial" id="+U/Yqw" />
            </Link>

            <div className="flex flex-col space-y-2 text-center md:flex-row md:items-center md:space-x-2 md:space-y-0">
              <span className="text-base font-medium tracking-wide text-gray-600">
                <FormattedMessage defaultMessage="Última atualização" id="6bWlJj" />
              </span>

              <time
                dateTime={lightFormat(lastUpdatedAt, "yyyy-MM-dd")}
                className="rounded-full border border-violet-300 bg-violet-50 px-2 py-1 text-sm font-medium text-violet-600"
              >
                <FormattedDate value={lastUpdatedAt} day="numeric" month="long" year="numeric" />
              </time>
            </div>
          </div>
        </div>
      </main>
    </FundamenteiWithTextLayout>
  );
}
